import { render, staticRenderFns } from "./ddo-policy.vue?vue&type=template&id=d8b51db4"
import script from "./ddo-policy.vue?vue&type=script&lang=js"
export * from "./ddo-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports